"use client";

import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";

import type { ReturnModalDTO } from "@repo/ui/api/getReturnModal";

interface ReturnModalContextValue {
  modalContent: ReturnModalDTO | null;
}

const ReturnModalContext = createContext<ReturnModalContextValue | null>(null);

interface ReturnModalProviderProps extends PropsWithChildren {
  modalContent: ReturnModalDTO | null;
}

export function ReturnModalProvider({ modalContent, children }: ReturnModalProviderProps) {
  return (
    <ReturnModalContext.Provider value={{ modalContent }}>{children}</ReturnModalContext.Provider>
  );
}

export function useReturnModal() {
  const context = useContext(ReturnModalContext);

  if (!context) {
    throw new Error("useReturnModal must be used within ReturnModalProvider");
  }

  return context;
}
